<template>
  <div class="table-container">
    <!-- 可滚动的表格部分 -->
    <div class="scrollable-table">
      <el-table
        :data="scrollableData"
        border
        style="width: 100%"
        size="medium"
        class="text-sm"
        header-row-class-name="bg-gray-100"
        :show-header="true"
        :row-class-name="getRowClassName"
      >
        <!-- 名称列插槽 -->
        <el-table-column v-bind="nameColumnProps">
          <template #default="scope">
            <slot
              name="nameColumn"
              :row="scope.row"
              :index="scope.$index"
            >
              {{ scope.row[nameColumnProps.prop] }}
            </slot>
          </template>
        </el-table-column>

        <!-- 类型 -->
        <el-table-column
          v-if="showType"
          prop="type"
          label="类型"
          width="140"
        >
        </el-table-column>
        <!-- 状态列（如果需要） -->
        <el-table-column
          v-if="showStatus"
          prop="status"
          label="状态"
          width="140"
        >
          <template slot-scope="scope">
            <div class="text-[12px]">
              <p :class="scope.row.displayStatus?.desc == '不符合条件' ? 'text-[#f00]' : ''">
                {{ scope.row.displayStatus?.desc }}
              </p>
              <div v-if="scope.row.reasonStatusList && scope.row.reasonStatusList.length">
                <p v-for="item in scope.row.reasonStatusList">
                  <el-tooltip
                    effect="dark"
                    :content="item.text"
                    placement="top"
                  >
                    <p class="text-[12px] text-[#999]">{{ item.desc }}</p>
                  </el-tooltip>
                </p>
              </div>
            </div>
          </template>
        </el-table-column>

        <!-- 基础数据列 -->
        <el-table-column
          v-for="item in tableBaseData"
          :key="item.key"
          :prop="item.key"
          :label="item.label"
          :sortable="item.sortable"
        >
          <template slot-scope="scope">
            <div>
              <span v-if="item.type == 'money'">{{ currency }} </span>
              <span>{{ scope.row[item.key] }}</span>
              <span v-if="item.type == 'percent'">%</span>
            </div>
          </template></el-table-column
        >
      </el-table>
    </div>

    <!-- 固定在底部的最后3行 -->
    <div
      class="fixed-bottom-table"
      v-if="fixedBottomData.length > 0"
    >
      <el-table
        :data="fixedBottomData"
        border
        style="width: 100%"
        size="medium"
        class="text-sm"
        :show-header="false"
        :row-class-name="getRowClassName"
      >
        <!-- 名称列插槽 -->
        <!-- <el-table-column v-bind="nameColumnProps">
          <template #default="scope">
            <slot
              name="nameColumn"
              :row="scope.row"
              :index="scrollableData.length + scope.$index"
            >
              {{ scope.row[nameColumnProps.prop] }}
            </slot>
          </template>
        </el-table-column> -->
        <el-table-column v-bind="nameColumnProps">
          <template slot-scope="scope">
            <div>
              <span
                >{{ scope.row.name }}
                <el-tooltip
                  effect="dark"
                  :content="scope.row.columnMark"
                  placement="top"
                >
                  <i
                    class="el-icon-info ml-1"
                    v-if="scope.row.columnMark"
                  ></i>
                </el-tooltip>
              </span>
            </div>
          </template>
        </el-table-column>
        <!-- 类型 -->
        <el-table-column
          v-if="showType"
          prop="type"
          label="类型"
          width="140"
        >
          <template slot-scope="scope">
            <div>--</div>
          </template>
        </el-table-column>
        <!-- 状态列（如果需要） -->
        <el-table-column
          v-if="showStatus"
          prop="status"
          label="状态"
          width="140"
        >
          <template slot-scope="scope">
            <div>--</div>
          </template>
        </el-table-column>

        <!-- 基础数据列 -->
        <el-table-column
          v-for="item in tableBaseData"
          :key="item.key"
          :prop="item.key"
          :label="item.label"
        >
          <template slot-scope="scope">
            <div>
              <span v-if="item.type == 'money'">{{ currency }} </span><span>{{ scope.row[item.key] }}</span>
              <span v-if="item.type == 'percent'">%</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { tableBaseData } from '../index';

export default {
  name: 'CommonTable',
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    nameColumnProps: {
      type: Object,
      default: () => ({
        prop: 'name',
        label: '名称',
        width: '180',
      }),
    },
    showStatus: {
      type: Boolean,
      default: false,
    },
    fixLength: {
      type: Number,
      default: 3,
    },
    currency: {
      type: String,
      default: 'USD',
    },
    showType: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableBaseData,
    };
  },
  computed: {
    scrollableData() {
      if (this.tableData.length <= this.fixLength) {
        return [];
      }
      return this.tableData.slice(0, -this.fixLength);
    },
    fixedBottomData() {
      if (this.tableData.length <= this.fixLength) {
        return this.tableData;
      }
      return this.tableData.slice(-this.fixLength);
    },
  },
  methods: {
    getRowClassName({ row }) {
      switch (row.dataType) {
        case 'summary':
          return 'summary-row';
        case 'estimate':
          return 'estimate-row';
        case 'adGroup':
          return 'adgroup-row';
        default:
          return '';
      }
    },
  },
};
</script>

<style scoped>
:deep(.el-table th) {
  background-color: #f7f9fb !important;
  color: #606266;
  font-weight: bold;
}

.table-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.scrollable-table {
  flex: 1;
}

.fixed-bottom-table {
  border-top: none;
}

.fixed-bottom-table :deep(.el-table) {
  border-top: none;
}

.fixed-bottom-table :deep(.el-table::before) {
  display: none;
}

:deep(.el-table .summary-row) {
  background-color: #eff6ff !important;
}

:deep(.el-table .estimate-row) {
  background-color: #f9fafb !important;
}

:deep(.el-table .adgroup-row) {
  background-color: #dbeafe !important;
}
</style>
